export default "__VITE_ASSET__q4ZLpt7p__"